<!--
 * @Descripttion: 选项卡属性设置
 * @Author: zenghua.wang
 * @Date: 2021-12-23 17:57:48
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-14 09:29:28
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <el-collapse-item title="选项卡设置">
      <el-form-item label="标签项">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addField"
        >新增</el-button>
      </el-form-item>

      <div style="padding-bottom: 20px">
        <el-table
          :data="data.children"
          v-loading="waitting"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column
            label="标签名"
            width="180"
          >
            <template slot-scope="scope">
              <el-radio
                v-model="data.option.currentTab"
                :label="scope.row.name"
              >
                <span style="white-space:nowrap;">{{ scope.row.label }}</span>
              </el-radio>
            </template>
          </el-table-column>

          <el-table-column
            label="标签值"
            width="180"
          >
            <template slot-scope="scope">
              <span style="white-space:nowrap;">{{ scope.row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                icon="el-icon-top"
                @click="sortField(scope.row, scope.$index, 'up')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-bottom"
                @click="sortField(scope.row, scope.$index, 'down')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="editField(scope.row, scope.$index)"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="deleteField(scope.row, scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 弹窗 -->
        <tabs-dialog
          :data="data"
          :dialog="dialog"
          :column="column"
          @change="updateField"
        />
      </div>

      <el-form-item label="类型">
        <el-radio-group
          v-model="data.option.type"
          size="mini"
        >
          <el-radio-button label="">文本型</el-radio-button>
          <el-radio-button label="card">卡片型</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="位置">
        <el-select
          v-model="data.option.position"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in positionList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="xa-form-tips">备注：位置设置仅对PC端有效</div>
      </el-form-item>

      <!-- <el-form-item label="内边距(px)">
        <el-input-number v-model="data.option.padding" />
      </el-form-item> -->

      <!-- <el-form-item label="背景色">
        <el-color-picker
          v-model="data.option.backgroundColor"
          :predefine="predefineColors"
        />
      </el-form-item> -->
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import { component, predefineColors } from '@/dragComponents/model/default.js'
import { createId } from '@/dragComponents/utils'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import tabsDialog from './dialog'

export default {
  name: 'config-tabs',
  components: {
    configBase,
    configAuth,
    tabsDialog
  },
  props: ['data', 'collapse'],
  data() {
    return {
      component: component,
      predefineColors: predefineColors,
      waitting: false,
      column: {},
      dialog: {
        show: false,
        title: '新增',
        action: 'add',
        index: null
      },
      positionList: [
        {
          label: 'top',
          value: 'top'
        },
        {
          label: 'right',
          value: 'right'
        },
        {
          label: 'bottom',
          value: 'bottom'
        },
        {
          label: 'left',
          value: 'left'
        }
      ]
    }
  },
  methods: {
    addField() {
      this.column = {
        label: '',
        name: createId(),
        children: []
      }
      this.dialog = {
        show: true,
        title: '新增',
        action: 'add',
        index: null
      }
    },
    editField(row, index) {
      this.column = row
      this.dialog = {
        show: true,
        title: '编辑',
        action: 'edit',
        index: index
      }
    },
    sortField(row, index, direction) {
      let len = this.data.children.length
      let stop = direction === 'up' ? 0 : len - 1
      if (index === stop) return
      let next = direction === 'up' ? index - 1 : index + 1
      this.waitting = true
      let temp = this.data.children[next]
      this.$set(this.data.children, index, temp)
      this.$set(this.data.children, next, row)
      setTimeout(() => {
        this.waitting = false
      }, 500)
    },
    updateField(val, callback) {
      let index = this.dialog.index
      let action = this.dialog.action
      if (action === 'edit') {
        this.$set(this.data.children, index, val)
      } else {
        this.data.children.push(val)
      }
      this.column = {}
      callback && callback(val)
    },
    deleteField(row, index, callback) {
      this.data.children.splice(index, 1)
      callback && callback(row)
    }
  }
}
</script>
